<template>
  <div class="my-container">
    <div class="robot-header fx">
      <el-button @click="dispatch('robot', 'activeIndexChange', 0)" icon="el-icon-arrow-left" type="text" size="mini">返回</el-button>
    </div>
    <el-scrollbar class="gungun" ref="scrollbar" style="overflow: hidden; height: 100%;margin-top:7px" wrap-style="overflow-x:hidden;">
      <el-table class="my-table"  left30 :data="deepTaskList" style="width: 100%">
        <el-table-column prop="keyword" label="关键词">
          <template slot-scope="{row}">
            <!-- 1-进行中 2-完成且获取 3-完成未获取 -->
            <span v-if="row.status == 1 || row.status == 3">
              {{row.keyword}}
            </span>
            <el-link @click="clickKeyword(row.keyword)" :underline="false" type="primary" v-else>{{row.keyword}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态" width="95">
          <template slot-scope="{row}">
            <span class="tasking" v-if="row.status == 1">进行中<i class="iconfont icon-jinhangzhong"></i></span>
            <span v-else>已完成</span>
          </template>
        </el-table-column>
      </el-table>
    </el-scrollbar>
  </div>
</template>

<script>
import emitter from '@/mixins/emitter'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'robotView2',
  mixins: [emitter],
  data () {
    return {}
  },
  computed: {
    ...mapState({
      deepTaskList: state => state.user.deepTaskList
    })
  },
  mounted () {
    // this.$refs.scrollbar.update()
  },
  methods: {
    clickKeyword (keyword) {
      if (this.$route.path == '/zxk/search/clueList') {
        this.$bus.$emit('deep-search', keyword.trim())
      } else {
        const query = { field: 'companyName', word: keyword.trim(), activeTab: 1 }
        if (window.__sendIframeLinkMessage({type: '2-1', query})) return
        this.$router.push({ path: '/zxk/search/clueList', query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.robot-header {
  position: absolute;
  top: 6px;
  left: 16px;
}
/deep/ {
  .robot-header {

  .el-button {
    color: #666666;
    display: flex;
    align-items: center;
    font-size: 12px;
    i{
      font-size: 12px;
    }
    span{
      font-size: 12px;
      color: #666666;
    }
  }
}
}
.my-container {
  padding-top: 24px;
  height: 378px;
}
.el-table.my-table::before {
  height: 0;
}
.el-table.my-table /deep/ {
  // color: #fff;
  thead {
    // color: #fff;
    th{
      background: #F7F7FA;
      .cell{
     height: 40px;
      line-height: 40px;
      }
    }
  }
  th,
  tr {
    &,
    &:hover td {
      // background-color: rgb(46, 49, 60) !important;
    }
    .cell{
      height: 40px;
      line-height: 40px;
    }
  }
  td,
  th {
    padding: 4px 0;
  }
  td,
  th.is-leaf {
    // background-color: rgb(46, 49, 60) !important;
    // border-bottom-color: #000;
  }
  th:nth-child(2),
  td:nth-child(2) {
    // border-left: 1px solid #000;
  }

  .tasking {
    color: rgb(79, 122, 253);
    i {
      margin-left: 4px;
    }
  }


  
}
/deep/ {
    .el-table thead tr th.el-table__cell{
    height: 40px;
  }
  .gungun{
    overflow: initial;
    .el-scrollbar__wrap::-webkit-scrollbar {
         width: 6px;
         height: 177px;
    }
    .el-scrollbar__wrap::-webkit-scrollbar-thumb{
     

      background: #BBBECA;
      border-radius: 3px;

    }
    /deep/ {
      .el-scrollbar__wrap{
margin-right: -24px;    padding-right: 10px;
      }
    }
  }
  
}
</style>
